export default __webpack_public_path__ + "static/media/drag.99933e13.svg";